import { render } from "./topicComment.vue?vue&type=template&id=c1b71aae&scoped=true"
import script from "./topicComment.vue?vue&type=script&lang=js"
export * from "./topicComment.vue?vue&type=script&lang=js"

import "./topicComment.vue?vue&type=style&index=0&id=c1b71aae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b71aae"]])

export default __exports__